import { useEffect, useState } from "react";
import {
  Button,
  Box,
  TextField,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import { UseFractionalList } from "./UseFractionalList";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import YesOrNoDialoge from "../../components/YesOrNoDialoge";
import { toMoney } from "../../util/Utils";

export default function OrderDetail(props) {
  const { getOrderById, addOneOrderMissing } = UseFractionalList();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [checkState, setCheckState] = useState({
    show: false,
    name: undefined,
    orderId: null,
  });
  const [state, setState] = useState({
    productID: undefined,
    product: undefined,
    operator: undefined,
    product: undefined,
    productCount: undefined,
    requestCount: undefined,
    productURL: undefined,
    supplier: undefined,
    shamsiLogdate: undefined,
    shamsiWarehouseLogdate: undefined,
    warehouseOperator: undefined,
    stateTitle: undefined,
    description: undefined,
  });

  useEffect(() => {
    if (props.orderID) {
      setProgress(true);
      getOrderById(props.orderID, (orderRes) => {
        setState({
          id: orderRes.id,
          isExpress: orderRes.isExpress,
          logDate: orderRes.logDate,
          shamsiLogDate: orderRes.shamsiLogDate,
          fullName: orderRes.fullName,
          mobile: orderRes.mobile,
          city: orderRes.city,
          phone: orderRes.phone,
          payment: orderRes.payment,
          totalPayment: orderRes.totalPayment,
          state: orderRes.state,
          fractional: orderRes.fractional,
        });
      });
    }
  }, [props.orderID]);

  return (
    <Dialog
      PaperProps={{
        elevation: 1,
      }}
      fullWidth
      maxWidth="md"
      open={props.open.show}
      onClose={() => props.setOpen({ ...props.open, show: false })}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <Typography
            sx={{
              color: "primary.main",
            }}
          >
            جزئیات سفارش
          </Typography>
          {state && (
            <Grid container spacing={2}>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.shamsiLogDate ? state.shamsiLogDate : ""}
                  label="تاریخ سفارش"
                  fullWidth
                  id="profile-user-info-shamsiLogDate-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  sx={{ input: { direction: "rtl" } }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.fullName ? state.fullName : ""}
                  label="نام و نام خانوادگی"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <TextField
                  value={state.mobile ? state.mobile : ""}
                  label="موبایل"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  sx={{ input: { direction: "rtl" } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={3}>
                <TextField
                  value={state.city ? state.city : ""}
                  label="شهر"
                  fullWidth
                  id="profile-user-info-fullName-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={3}>
                <TextField
                  value={state.payment ? state.payment : ""}
                  label="نوع پرداخت"
                  fullWidth
                  id="profile-user-info-payment-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
              <Grid item xs={4} sm={4} md={3}>
                <TextField
                  value={state.totalPayment ? toMoney(state.totalPayment) : ""}
                  label="مبلغ سفارش(تومان)"
                  fullWidth
                  id="profile-user-info-totalPayment-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                  sx={{ input: { direction: "rtl" } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={3}>
                <TextField
                  value={state.state ? state.state : ""}
                  label="وضعیت"
                  fullWidth
                  id="profile-user-info-state-box"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    readOnly: true,
                  }}
                  variant="filled"
                />
              </Grid>
            </Grid>
          )}
          <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
            {state.fractional && (
              <Button
                sx={{ width: "90px" }}
                onClick={() => {
                  setCheckState({
                    show: true,
                    name: "افزودن سفارش به لیست کسری",
                    orderId: state.id,
                  });
                }}
                variant="contained"
                color="secondary"
              >
                افرودن
              </Button>
            )}
            <Button
              sx={{ width: "90px" }}
              onClick={() => props.setOpen({ ...props.open, show: false })}
              variant="outlined"
            >
              بستن
            </Button>
          </Box>
        </Box>
      </DialogContent>
      <YesOrNoDialoge
        checkState={checkState}
        setCheckState={setCheckState}
        callback={() => {
          let requestModel = {
            OrderID: checkState.orderId,
          };
          setProgress(true);
          addOneOrderMissing(requestModel, () => {
            setProgress(true);
            getOrderById(props.orderID, (orderRes) => {
              setState({
                id: orderRes.id,
                isExpress: orderRes.isExpress,
                logDate: orderRes.logDate,
                shamsiLogDate: orderRes.shamsiLogDate,
                fullName: orderRes.fullName,
                mobile: orderRes.mobile,
                city: orderRes.city,
                phone: orderRes.phone,
                payment: orderRes.payment,
                totalPayment: orderRes.totalPayment,
                state: orderRes.state,
                fractional: orderRes.fractional,
              });
            });
            setCheckState({ show: false });
          });
        }}
      />
    </Dialog>
  );
}
